import { commonChecks } from '@xhs/ozone-detector'

export default function isSupport(methodName) {
  if (!process.env.BROWSER) {
    return false
  }

  const handler = commonChecks.isIOS
    ? (window.webkit?.messageHandlers)
    : window.xhsbridge

  return handler && !!handler[methodName]
}
